import { render, staticRenderFns } from "./PublicationCreatePet.vue?vue&type=template&id=b6af7e58&scoped=true&"
import script from "./PublicationCreatePet.vue?vue&type=script&lang=js&"
export * from "./PublicationCreatePet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6af7e58",
  null
  
)

export default component.exports